<template>
    <div class="page container">
        
        <div class="pure-g contentArea">

            <div class="pure-u-1 pure-u-lg-18-24 left">
                <p class="sectionTitle">Saved Events 
                    <router-link to="events" class="linkBtn">View All <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                </p>
                <Events 
                    grid="3"
                    type="userSaved"
                ></Events>
                <div class="center viewMoreArea">
                    <router-link to="events" class="linkBtn center">View All Events <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                </div>
            </div>

            <div class="pure-u-1 pure-u-lg-6-24 right">
                
            </div>

        </div>

    </div>
</template>

<script>
    import Events from '../../components/Events.vue'

    export default {
        metaInfo: {
            title: 'Saved Events',
            meta: [
                {
					property: 'og:title',
                    content: 'Saved Events',
                    template: '%s | OneMgl Community',
                },
                {
					property: 'twitter:title',
					content: 'Saved Events',
					template: '%s | OneMgl Community'
				}
            ]
        },
        components: {
            Events
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Account/Saved_Events.vue